import { Link } from "react-router-dom";

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export function playerFromLabel(label) {
  const m = /^(.*?) \((\w+)\) /.exec(label || "");
  return m ? { name: m[1], team: m[2], slug: slugify(`${m[1]} ${m[2]}`) } : null;
}

export function PlayerLink({ player, label, className = "" }) {
  const p = player || playerFromLabel(label);
  if (!p || !label?.startsWith(p.name)) return <span className={className}>{label}</span>;
  const rest = label.slice(p.name.length);
  return (
    <span className={className}>
      <Link to={`/players/${p.slug}`} data-testid="player-link" onClick={(e) => e.stopPropagation()} className="text-white underline decoration-emerald-500/50 decoration-dotted underline-offset-2 transition-colors hover:text-emerald-300 hover:decoration-emerald-400">
        {p.name}
      </Link>
      {rest}
    </span>
  );
}
